<template>
  <div>
    <section class="hot-section pc-hot">
      <div class="hot-container pc-hot-container">
        <header class="hot-title section-title-wrapper">
          <div class="title-left">
            <h1 class="section-title" v-text="$t('home.hot_title')"></h1>
            <h2 class="section-sub-title" v-text="$t('home.hot_sub_title')"></h2>
          </div>
          <div class="hot-more">
            <a href="/info">{{$t('home.hot_more')}}</a>
          </div>
        </header>
        <div class="swiper-container swiper-hot">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in hotArray" :key="item.id" :title="item.title">
              <div class="img-slide-wrapper">
                <a
                  :href="item.href"
                  target="_blank"
                  class="hot-link"
                  :style="'background-image:url('+item.thumbnail+')'"
                ></a>
              </div>
            </div>
          </div>
          <div v-show="hotArray.length>4" class="swiper-hot-pagination swiper-pagination"></div>
        </div>
      </div>
    </section>
    <div class="wap-hotspots">
      <div class="hot-container">
        <header class="wap-title-wrapper">
          <div class="wap-title-left">
            <div class="wap-section-title" v-text="$t('home.hot_title')"></div>
            <div class="wap-section-sub-title" v-text="$t('home.hot_sub_title')"></div>
          </div>
          <div class="title-more">
            <a href="/info">
              {{$t('home.hot_more')}}
              <div class="wap-more-arrow"></div>
            </a>
          </div>
        </header>
        <div class="hot-content">
          <div class="swiper-container wap-swiper-hot" id="wap-swiper-hot">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in hotArray" :key="item.id" :title="item.title">
                <div class="img-slide-wrapper">
                  <a
                    :href="item.href"
                    target="_blank"
                    class="hot-link"
                    :style="'background-image:url('+item.thumbnail+')'"
                  ></a>
                </div>
              </div>
            </div>
            <div class="wap-swiper-hot-pagination swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "../common/common";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import {animationScroll} from '@/assets/js/common'
import { getColumnList } from "../../../request/api";
export default {
  data() {
    return {
      hotArray: [],
      pcSwiper:null,
      wapSwiper:null,
      timer:null,
    };
  },
  methods: {
    init() {
      var _this = this;
      this.getHotList();
      this.initSwiper();
    },
    getHotList() {
      var that = this;
      var localHotList = localStorage.getItem("hotList");
      var lang =this.$cookies.get("language");
      if (localHotList) {
        //先读取缓存的hotList
        that.hotArray = JSON.parse(localHotList);
      }
      getColumnList({ language: lang||global.initLang, columnType: "hotspot" })
        .then(res => {
          if (res.success) {
            that.hotArray = res.columnList;
            localStorage.setItem("hotList", JSON.stringify(res.columnList));
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    initSwiper() {
      var _this = this;
      _this.pcSwiper = new Swiper(".swiper-hot", {
        autoplay: true,
        delay:5000,
        loop: true,
        speed: 2000,
        slidesPerView: 4,
        slidesPerGroup: 4,
        touchRatio: 2, //触摸变快
        observer: true,
        //   watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-hot-next",
          prevEl: ".swiper-hot-prev"
        },
        pagination: {
          el: ".swiper-hot-pagination",
          clickable: true
        },
        on: {
          resize: function() {
            //窗口变化了
            _this.pcSwiper.update();
          },
          touchStart:function () {
            clearTimeout(_this.timer);
            _this.pcSwiper.autoplay.stop();
            _this.timer= setTimeout(() => {
              _this.pcSwiper.autoplay.start();
            }, 3000);
          }
        }
      });
      _this.pcSwiper.el.onmouseover = function() {
        _this.pcSwiper.autoplay.stop();
      };
      _this.pcSwiper.el.onmouseout = function() {
        _this.pcSwiper.autoplay.start();
      };
      this.wapSwiper = new Swiper("#wap-swiper-hot", {
        // autoplay:true,
        speed: 500,
        slidesPerView: 3, //重要 可以去swiper搜索
        centeredSlides: true, //重要
        initialSlide: 1,
        spaceBetween: 20,
        effect: "left",
        observer:true,
        observeParents:true,
        disableOnInteraction: false,
        pagination: {
          el: ".wap-swiper-hot-pagination",
          clickable: true
        },
        on:{
          resize:function(){
            _this.wapSwiper.update();
          },
          touchStart:function () {
            clearTimeout(_this.timer);
            _this.wapSwiper.autoplay.stop();
            _this.timer= setTimeout(() => {
              _this.wapSwiper.autoplay.start();
            }, 3000);
          }
        }
      });
    }
  },
  mounted() {
    this.init();
    animationScroll($('.pc-hot-container'))
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pc/index/hotSection.vue